// @flow
import type {Node, Edge, Element} from '../types';

type NodeChildren = Array<any>;
type NodeAttributes = {[string]: any};

const buildStateDiagramNode = (
  attributes: NodeAttributes,
  children: NodeChildren,
): Node => {
  const {id, state} = attributes;
  const node: Node = {
    id,
    type: 'state',
    position: {x: 0, y: 0}, // position the nodes after the initial render so we know their height / widths
    data: {text: children},
  };

  if (state) {
    node.data.state = state;
  }

  return node;
};

const buildStateDiagramEdge = (
  attributes: NodeAttributes,
  children: NodeChildren,
): Edge => {
  const {from, to, label} = attributes;
  const edge: Edge = {
    id: `edge-${from}-${to}`, // each edge needs a unique ID
    source: from,
    target: to,
    arrowHeadType: 'arrowclosed',
    labelStyle: {
      fontFamily: 'Menlo',
    },
    labelBgStyle: {
      fill: '#F6F8FA',
      filter: 'drop-shadow(-1px 1px 1px rgb(60 66 87 / 8%))',
    },
  };
  if (label) {
    edge.label = label;
  }
  return edge;
};

export const buildStateDiagram = (
  attributes: NodeAttributes,
  children: NodeChildren | null,
): Array<Element> => {
  if (!children) {
    return [];
  }

  const elements = children.map((c) => {
    if (c.name !== 'node' && c.name !== 'edge') {
      // We should never get here due to Markdoc tag validation
      return null;
    }
    return c.name === 'node'
      ? buildStateDiagramNode(c.attributes, c.children)
      : buildStateDiagramEdge(c.attributes, c.children);
  });
  return elements.filter(Boolean);
};
